import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDspStart = loadable(() => import('./DspStart'), {
  fallback: <LoadingScreen />,
});

export default LoadableDspStart;
